import React, { FC } from 'react'

const ButtonCap: FC<any> = (props) => (
  <svg width="71" height="48" viewBox="0 0 71 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M47 0C36.771 0 28.0367 6.39926 24.5819 15.4128C24.272 16.2214 22.728 16.2214 22.4181 15.4128C18.9634 6.39926 10.229 3.21463e-06 0 4.10887e-06L1.52588e-05 48C10.229 48 18.9634 41.6007 22.4181 32.5872C22.728 31.7786 24.272 31.7786 24.5819 32.5872C28.0367 41.6007 36.771 48 47 48C60.2548 48 71 37.2548 71 24C71 10.7452 60.2548 0 47 0Z" />
  </svg>
)

export default ButtonCap
